import Snackbar from '@kaidam/fc-shared/src/frontend/components/system/Snackbar'
export default Snackbar